import { render, staticRenderFns } from "./AdminWhitelistView.vue?vue&type=template&id=37af6108&scoped=true"
import script from "./AdminWhitelistView.vue?vue&type=script&lang=js"
export * from "./AdminWhitelistView.vue?vue&type=script&lang=js"
import style0 from "./AdminWhitelistView.vue?vue&type=style&index=0&id=37af6108&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af6108",
  null
  
)

export default component.exports